module.exports = __webpack_public_path__ + "img/icon-addimgs.a98d5449.png";